import { axiosInstance } from "./client";
import { MIME_TYPE_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { FormConfigurationTheme } from "@rumble-it/common-lib/types/formConfigurationTheme.interface";

interface GetFormConfigurationThemeResponse {
  formConfigurationTheme: FormConfigurationTheme;
}

export const getFormConfigurationTheme = async (
  themeId: string,
): Promise<GetFormConfigurationThemeResponse> =>
  axiosInstance
    .get<FormConfigurationTheme>(`/themes/${themeId}/serve`, {
      headers: {
        Accept: MIME_TYPE_JSON,
        "Content-Type": MIME_TYPE_JSON,
      },
    })
    .then((response) => ({
      formConfigurationTheme: response.data,
    }));
